// Calculator.js
import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import axios from "axios";
import API_BASE_URL from "../../config/api";
import { makeStyles } from "@material-ui/core/styles";
import { usePageStyles } from "../common/pageStyles";
import HalfDiagram from "../HalfDiagram"; // Import HalfDiagram component
import HalfTable from "../HalfTable"; // Import HalfTable component
import HalfDiagramRealizujaca from "../HalfDiagramRealizujaca";

const useStyles = makeStyles((theme) => ({
  panels: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(2.5),
    alignItems: "flex-start",
  },
  panel: {
    flex: "1 1 420px",
    minWidth: 0,
    padding: theme.spacing(3),
    boxSizing: "border-box",
  },
  panelTitle: {
    margin: 0,
    fontSize: 20,
    fontWeight: 800,
    color: "#0d47a1",
  },
  panelSubtitle: {
    margin: "2px 0 20px",
    fontSize: 14,
    color: "#666",
  },
}));

const headers = {
  "Content-Type": "application/json",
  // Getter: token czytany przy każdym żądaniu, a nie raz przy ładowaniu skryptu
  // (inaczej po zalogowaniu bez odświeżenia strony wysyłany byłby stary/pusty token).
  get Authorization() {
    return `Bearer ${localStorage.getItem("token")}`;
  },
};

const BASE_URL = API_BASE_URL;

const Calculator = () => {
  const classes = useStyles();
  const page = usePageStyles();
  const [userData, setUserData] = useState([]);

  const [userName, setUserName] = useState([]);

  const fetchData = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/calculator`, {
        headers: headers,
      });
      setUserData(response.data);
    } catch (error) {
      console.error("Error fetching user data:", error);
      toast.error("Error fetching user data");
    }
  };

  const fetchUsers = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/list/uzytkownicy`, {
        headers: headers,
      });
      setUserName(response.data);
    } catch (error) {
      console.error("Error fetching user data:", error);
      toast.error("Error fetching user data");
    }
  };

  const refreshData = () => {
    fetchData();

    fetchUsers();
  };

  useEffect(() => {
    // Initial data fetch
    refreshData();

    const intervalId = setInterval(() => {
      refreshData();
    }, 300000);

    return () => clearInterval(intervalId);
  }, []);

  const usernameCountsPrzygotowujaca = userData.reduce((counts, user) => {
    const username =
      user.osobaPrzygotowujacaOdprawe || "Brak przypisanych spraw";
    counts[username] = (counts[username] || 0) + 1;
    return counts;
  }, {});

  const usernameCountsRealizujaca = userData.reduce((counts, user) => {
    const username = user.osobaWysylajacaOdprawe || "Brak przypisanych spraw";
    counts[username] = (counts[username] || 0) + 1;
    return counts;
  }, {});

  return (
    <div>
      <div className={page.pageHeader}>
        <div>
          <h1 className={page.title}>Kalkulator ilości spraw</h1>
          <div className={page.subtitle}>Aktualne odprawy: osoba przygotowująca i wysyłająca</div>
        </div>
      </div>

      <div className={classes.panels}>
        <div className={`${page.card} ${classes.panel}`}>
          <h2 className={classes.panelTitle}>Osoba przygotowująca</h2>
          <div className={classes.panelSubtitle}>Liczba spraw wg osoby</div>
          <HalfTable
            usernameCounts={usernameCountsPrzygotowujaca}
            allowedNames={userName}
          />
          <HalfDiagram
            userData={userData}
            property="osobaPrzygotowujacaOdprawe"
            allowedNames={userName}
          />
        </div>
        <div className={`${page.card} ${classes.panel}`}>
          <h2 className={classes.panelTitle}>Osoba wysyłająca</h2>
          <div className={classes.panelSubtitle}>Liczba spraw wg osoby</div>
          <HalfTable
            usernameCounts={usernameCountsRealizujaca}
            allowedNames={userName}
          />
          <HalfDiagramRealizujaca
            userData={userData}
            property="osobaWysylajacaOdprawe"
            allowedNames={userName}
          />
        </div>
      </div>
    </div>
  );
};

export default Calculator;
